import { Modal } from '../../components/modal/modal';
import { useState } from 'react';
import { Button } from '../../components/form/button';
import { toast } from '../../util/toasts';
import { LocationSelect } from '../location/select/location-select';
import { SelectForm } from '../../components/select-form/select-form';
import { Typography } from '../../components/typography/typography';
import { useTaxApiV1 } from '../../clients/quipli-service/tax/tax-api-v1';
import { TaxCode } from '../../clients/quipli-service/tax/tax';

export const TaxLocationModal = ({
  isOpen,
  close,
  taxCodes,
}: {
  isOpen: boolean;
  close: (isWrite: boolean) => void;
  taxCodes: TaxCode[];
}) => {
  const { createTaxLocation } = useTaxApiV1();
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [taxLocationRequest, setTaxLocationRequest] = useState<{
    taxCodeId?: string;
    locationId?: number;
    shippingType: string;
  }>({ shippingType: 'inStore' });

  async function doSave() {
    try {
      if (!taxLocationRequest.locationId || !taxLocationRequest.taxCodeId) {
        toast('Missing required information', 'error');
        return;
      }
      setIsSaving(true);
      await createTaxLocation({
        taxCodeId: taxLocationRequest.taxCodeId,
        locationId: taxLocationRequest.locationId,
        shippingType: 'inStore',
      });
      toast('Tax Location Assignment created successfully');
      close(true);
    } catch (e: any) {
      toast('Failed to save Tax Location Assignment', 'error');
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <Modal
      title="Create Tax Location Assignment"
      isOpen={isOpen}
      close={() => close(false)}
      actions={
        <>
          <Button className="button button-secondary" disabled={isSaving} onClick={() => close(false)}>
            Cancel
          </Button>
          <Button
            className="button button-yellow"
            disabled={isSaving || !taxLocationRequest.locationId || !taxLocationRequest.taxCodeId}
            onClick={doSave}
          >
            Create
          </Button>
        </>
      }
    >
      <div className="flex flex-column gap-2">
        <div>
          <Typography type={'text-md'}>Location:</Typography>
          <LocationSelect
            setLocation={(l) =>
              setTaxLocationRequest((prev) => {
                return { ...prev, locationId: l?.id };
              })
            }
          />
        </div>
        <div>
          <Typography type={'text-md'}>Tax Code:</Typography>
          <SelectForm
            options={taxCodes.map((_) => {
              return { label: _.name, value: _.id };
            })}
            menuPortalTarget={document.body}
            onChange={(e) =>
              setTaxLocationRequest((prev) => {
                return { ...prev, taxCodeId: e?.value };
              })
            }
          />
        </div>
      </div>
    </Modal>
  );
};
